import Alert from "features/shared/alerts/components/Alert";
import AlertSimplified from "features/shared/alerts/dtos/AlertSimplified";

export enum AlertsActionTypes {
  SET_ALERTS = "@@alerts/SET_ALERTS",
  REMOVE_ALERT = "@@alerts/REMOVE_ALERT",
}

export type AlertsAction =
  | { type: AlertsActionTypes.SET_ALERTS; data: AlertSimplified[] }
  | { type: AlertsActionTypes.REMOVE_ALERT; data: number };

export const setAlerts = (data: AlertSimplified[]): AlertsAction => {
  return {
    type: AlertsActionTypes.SET_ALERTS,
    data: data,
  };
};

export const removeAlert = (data: number): AlertsAction => {
  return {
    type: AlertsActionTypes.REMOVE_ALERT,
    data: data,
  };
};
